export default {
  isLoading: false,
  form: {
    origin: '',
    destination: '',
    out_time: null,
    return_time: null,
    has_car_access: false,
  },
  journeyType: 'single',
  errors: {
    return_time: false,
    origin: false,
    destination: false,
    out_time: false,
  },
  defaultError: false,
}
